/**
 * @deprecated
 * 获取用户基础信息
 */
export var CGI_GET_USER_MARK = '/sdc/getusermarkname';
/**
 * 获取用户基础信息
 */
export var CGI_OWNER_VIP_LEVEl = '/api/personalize/owner/viplevel';
/**
 * 文档点赞接口
 */
export var CGI_LIKE = '/cgi-bin/like/like';
/**
 * 设置点赞打开/关闭接口
 */
export var CGI_LIKE_ENABLE_SET = '/cgi-bin/like/enable/set';
/**
 * 文档点赞类型接口
 */
export var CGI_LIKE_ICON = '/cgi-bin/like/icon/list';
/**
 * 是否禁止点赞接口（单文档灰度判断）
 */
export var CGI_LIKE_BANNED = '/cgi-bin/like/disabled';
/**
 * 文档点赞总数接口
 */
export var CGI_LIKE_COUNT = '/cgi-bin/like/record/count';
/**
 * 文档点赞列表接口
 */
export var CGI_LIKE_LIST = '/cgi-bin/like/record/list';
